import React, { useState, useCallback, Dispatch, SetStateAction } from "react";

const initialValues: NotificationProps = {
  message: "",
  status: 200,
  diplayType: "Alert"
};

export const NotificationsContext = React.createContext<NotificationsContextProviderProps>({
  notification: initialValues,
  addNotification: (message: string, status: StatusType, diplayType: NotificationType = "Alert") => { },
  removeNotification: () => { },
  isNotificationVisible: false,
  setIsNotificationVisible: () => false,
});

const NotificationsContextProvider: React.FC<Props> = ({ children }) => {
  const [notification, setNotification] = useState<NotificationProps>(initialValues);
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);

  const removeNotification = () => setNotification(initialValues);

  const addNotification = (message: string, status: StatusType, diplayType: NotificationType = "Alert") => {
    setNotification({ message, status, diplayType });
  }

  const contextValue = {
    notification,
    addNotification: useCallback((message: string, status: StatusType, diplayType: NotificationType = "Alert") => addNotification(message, status, diplayType), []),
    removeNotification: useCallback(() => removeNotification(), []),
    isNotificationVisible,
    setIsNotificationVisible,
  };

  return (
    <NotificationsContext.Provider value={contextValue}>
      {children}
    </NotificationsContext.Provider>
  );
};

interface Props {
  children?: React.ReactNode;
}

interface NotificationsContextProviderProps {
  notification: NotificationProps;
  addNotification: (message: string, status: StatusType, diplayType?: NotificationType) => void;
  removeNotification: () => void;
  isNotificationVisible: boolean;
  setIsNotificationVisible: Dispatch<SetStateAction<boolean>>;
}

interface NotificationProps {
  message: string;
  status: StatusType;
  diplayType?: NotificationType;
}

type NotificationType = "Modal" | "Alert";

type StatusType = 200 | 400 | 500;

export default NotificationsContextProvider;